import React from 'react';
var selfStyles = require('./styles.scss');
var ListAthletesItemAthleteScoreRouteItemLoading = function (props) {
    var overflowStyle = props.width > 50
        ? { minWidth: props.width }
        : {};
    return (React.createElement("div", { className: selfStyles.athleteScoreRouteItem + " " + selfStyles.loader, style: overflowStyle },
        React.createElement("div", { className: selfStyles.loader })));
};
export default ListAthletesItemAthleteScoreRouteItemLoading;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemAthleteScoreRouteItemLoading.tsx
// module id = 711
// module chunks = 0